import React from 'react';
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryTooltip,
  VictoryLabel
} from 'victory';
import './Charts.css';

const customTheme = {
  chart: {
    padding: { top: 40, bottom: 50, left: 60, right: 40 }
  },
  axis: {
    style: {
      axis: {
        stroke: '#64748b'
      },
      grid: {
        stroke: 'rgba(100, 116, 139, 0.1)'
      },
      tickLabels: {
        fill: '#94a3b8',
        fontSize: 10,
        angle: -45,
        textAnchor: 'end'
      }
    }
  }
};

const BarChart = ({ 
  data = [], 
  title = 'Page Views', 
  xAxis = 'Page', 
  yAxis = 'Views' 
}) => {
  const formattedData = data.map(point => ({
    x: point.page || point.label,
    y: point.views || point.value,
    label: point.page || point.label
  }));

  return (
    <div className="chart bar-chart">
      <h3 className="chart-title">{title}</h3>
      <VictoryChart
        theme={customTheme}
        domainPadding={20}
        height={300}
        padding={{ top: 40, bottom: 100, left: 60, right: 40 }}
      >
        <VictoryAxis
          tickFormat={(t) => t}
          label={xAxis}
          style={{
            tickLabels: {
              fontSize: 8,
              angle: -45,
              textAnchor: 'end',
              fill: '#94a3b8'
            }
          }}
        />
        <VictoryAxis
          dependentAxis
          label={yAxis}
          style={{
            tickLabels: { fill: '#94a3b8' }
          }}
        />
        <VictoryBar
          data={formattedData}
          style={{
            data: {
              fill: ({ datum }) => {
                const opacity = 0.6 + (datum.y / Math.max(...formattedData.map(d => d.y))) * 0.4;
                return `rgba(16, 185, 129, ${opacity})`;
              },
              width: 20
            }
          }}
          labels={({ datum }) => `${datum.y} views`}
          labelComponent={
            <VictoryTooltip
              style={{ fontSize: 10, fill: '#fff' }}
              flyoutStyle={{
                stroke: 'none',
                fill: 'rgba(0, 0, 0, 0.8)'
              }}
            />
          }
          animate={{
            duration: 2000,
            onLoad: { duration: 1000 }
          }}
        />
      </VictoryChart>
    </div>
  );
};

export default BarChart; 